import React from "react";
import DataGrid from '@dataGrid';
import RoutesGridConfig from "./RoutesGridConfig";
import { observer, inject } from "mobx-react";
import { autorun, reaction } from "mobx";
import appConstant from "../../../../appConstants";
import MESSAGES from "../../../../appMessages";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { postData, getDataWithQueryString } from "../../../../api/componentAPIs";
import {
  convertDateTimeToTimeString,
  isTimeValid,
} from '@dataGrid/gridUtilities';
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { isEqual } from "lodash/lang";
import UNRTDShipmentsModal from "./UNRTDShipmentsGrid";
import StatusBar from '@dataGrid/components/StatusBar';
import CheckViolation from "../../../common/checkViolation";
import MergeRoutesDialog from "../Common/MergeRoutesDialog";
import AddRouteToLassoModal from "../Common/AddRouteToLassoModal";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";
import { withFeatureFlags } from "../../../../userProfile/featureFlagsContext";
import { withAppConfig } from "../../../../appConfigContext";
import PrintLoadingGuide from "./PrintLoadingGuide";
import { getUniqueDriverCount, isAnchorPointEquipmentMismatch, isEquipmentMismatch, routeHasAssignedDriver } from "./utils";
import Events from "../../../../utilities/EventEmitter";
import { APP_EVENT_NAMES } from "../../../../signalR/constants";
import { sanitizeInput } from "../../../../utilities/dataUtils";
import HoldProPopup from "../ShipmentsView/HoldProPopup";
import {handleWhiteGloveRouteNameChange} from "../Common/whiteGloveRouteUtils";

@inject("IBPlanningStore", "CommonStore")
@observer
class RoutesGrid extends React.Component {
  constructor(props) {
    super(props);
    this.enableDoorForRouteGrid = this.props.featureFlags.isFeatureEnabled(
      appConstant.features.EnableDoorForRoutesGrid
    );
    this.gridConfig = new RoutesGridConfig({
      userConfig: this.props.userData.userProfile?.columnPref,
      featureFlags: {
        IsWeightBasedRoutingEnabled: this.props.featureFlags.isFeatureEnabled(
          appConstant.features.isWeightBasedRouting
        ),
        DisableReturnToTerminalOption: this.props.featureFlags.isFeatureEnabled(
          appConstant.features.DisableReturnToTerminalOption
        ),
        EnableAssignDriverToRoute: this.props.configJSON?.enableAssignDriverToRoute,
        EnableDoorForRoutesGrid: this.enableDoorForRouteGrid,
        EnableRevenueFieldsOnUI: this.props.configJSON?.enableRevenueFieldsOnUi
      },
      ROUTENAME_EDITOR_PARAMS: this.props.configJSON?.routeNameEditParams,
      trailersData: this.props.CommonStore.availableTrailers,
    });
    this.state = {
      quickFilterText: "",
      showUnrtdShipmentModal: false,
      showMergeRoutesModal: false,
      filterData: "",
      isLassoActiveWithShipments: false,
      showHoldProPopup: false
    };
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.selectedRoutes = [];
    this.gridApi = {};
    this.rowSelectionTimeOut = null;
    this.gridContext = {
      trailersData: this.props.CommonStore.availableTrailers,
      newShipments: this.props.IBPlanningStore.newShipments,
      hasEquipmentMismatch: this.hasEquipmentMismatch,
      hasAnchorPointEquipmentMismatch: this.hasAnchorPointEquipmentMismatch,
      stopsList: this.props.IBPlanningStore.stopsList,
      enableFMECustomer: this.props.configJSON?.enableFMECustomer,
      enableTailLoad: this.props.featureFlags.isFeatureEnabled(appConstant.features.EnableTailLoadInCustomerManagement),
      getRouteProArrivingLateViolation: this.getRouteProArrivingLateViolation,
      planDate :this.props.userData.userProfile.planDate,
      getTrailerNameForRoute: this.props.IBPlanningStore.getTrailerNameForRoute,
      getTrailerInfo: this.props.CommonStore.getTrailerInfo,
    };
    this.datarefreshed = true;
  }
  componentDidMount() {
    this.getDoorData();
    this.props.glEventHub.on(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.on(`${this.gridHeaderId}_runTSP`, this.runTSP);
    this.props.glEventHub.on(
      "setIsLassoActiveWithShipments",
      this.setIsLassoActiveWithShipments
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_mergeRoutes`,
      this.confirmMergeRoute
    );
    this.props.glEventHub.on(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.autorunDispose = autorun(() => {
      if (
        !isEqual(
          this.selectedRoutes.map((route) => route.routeName),
          this.props.IBPlanningStore.selectedRouteNameList
        )
      ) {
        // this will be true when selectedRouteNameList is updated outside this component eg: findNearbyRoutes
        this.selectRoutes(
          this.props.IBPlanningStore.selectedRouteNameList,
          !this.datarefreshed
        );
      }
    });

    this.autorunRouteUpdateDispose = autorun(() => {
      if (this.props.IBPlanningStore.routesList.slice()) {
        this.datarefreshed = true;
      }
    });

    this.autorunTrailerOrNewShipmentsUpdate = autorun(() => {
      if (
        this.props.CommonStore.availableTrailers.slice() ||
        (this.props.IBPlanningStore.newShipments.data &&
          this.props.IBPlanningStore.newShipments.data.slice())
      ) {
        this.gridContext.trailersData = this.props.CommonStore.availableTrailers;
        this.refreshViolationColumn();
      }
    });

    this.routeToTrailerMapDispose = reaction(
      () => ({
        routeWithTrailerName: this.props.IBPlanningStore.routeWithTrailerName,
        trailerInfo: this.props.CommonStore.trailerInfo
      }),
      () => {
        this.refreshViolationColumn();
      }
    );
    Events.on(APP_EVENT_NAMES.IBPLANNING.openUnrtdModal, this.openUNRTDModal)
  }

  componentWillUnmount() {
    this.props.glEventHub.off(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.off(`${this.gridHeaderId}_runTSP`, this.runTSP);
    this.props.glEventHub.off(
      "setIsLassoActiveWithShipments",
      this.setIsLassoActiveWithShipments
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_mergeRoutes`,
      this.confirmMergeRoute
    );
    this.props.glEventHub.off(
      `${this.gridHeaderId}_BulkUpdate`,
      this.onBulkUpdate
    );
    this.autorunDispose && this.autorunDispose();
    this.autorunRouteUpdateDispose && this.autorunRouteUpdateDispose();
    this.autorunTrailerOrNewShipmentsUpdate?.();
    this.routeToTrailerMapDispose?.();
    Events.off(APP_EVENT_NAMES.IBPLANNING.openUnrtdModal, this.openUNRTDModal)
    this.clearSelectionTimeout();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.getDoorData();
      this.gridContext.planDate = this.props.userData.userProfile.planDate;
    }
    if (this.props.featureFlags !== prevProps.featureFlags) {
      this.gridContext.enableTailLoad = this.props.featureFlags.isFeatureEnabled(appConstant.features.EnableTailLoadInCustomerManagement);
    }
  }

  getRouteProArrivingLateViolation = (routeId) => {
    return this.props.IBPlanningStore.routeProLateStatus?.[routeId]
  }

  setIsLassoActiveWithShipments = (isLassoActiveWithShipments) => {
    this.setState({ isLassoActiveWithShipments });
  }

  clearSelectionTimeout = () => {
    if (this.rowSelectionTimeOut) {
      clearTimeout(this.rowSelectionTimeOut);
      this.rowSelectionTimeOut = null;
    }
  }

  getDoorData = () => {
   if (this.enableDoorForRouteGrid){
      getDataWithQueryString(
        "GetDoorData",
        `terminalId=${this.props.userData.userProfile.terminal.id}`
      ).then((response) => {
        if (response?.status >= 200 && response?.status < 400) {
          this.props.IBPlanningStore.setDoorList(response.data || [])
        }
      }); 
    }
  };
  
  hasEquipmentMismatch = (route) => {
    if(!route.routeId) return false;
    const trailer = this.props.CommonStore.availableTrailers.find(trailer => trailer.trailerId === route.trailerId);
    if (!trailer) return false;
    const stopsWithMismatchedTrailerCount = this.props.IBPlanningStore.getRouteStops(
      route.routeId
    ).filter((stop) => stop.stopType !== appConstant.ROUTE_STOP_TYPES.AP && isEquipmentMismatch(trailer, stop)).length;
    return stopsWithMismatchedTrailerCount > 0;
  }
  
  hasAnchorPointEquipmentMismatch = (route) => {
    if (!route.routeId) return false;
    const trailer = this.props.CommonStore.availableTrailers.find(
      (trailer) => trailer.trailerId === route.trailerId
    );
    const anchorPoint = this.props.IBPlanningStore.getRouteStops(route.routeId).find(
      (stop) => stop.stopType === 'AP'
    );
    if (!trailer || !anchorPoint) return false;
    return isAnchorPointEquipmentMismatch(trailer, anchorPoint);
  };
    
  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };

  refreshViolationColumn = () => {
    if (this.gridApi.refreshCells) {
      this.gridApi.refreshCells({ columns: ["violation"], force: true });
    }
    this.gridApi.onFilterChanged?.();
  };

  syncSelectionOnGridReady = () => {
    // Skip initial sync when refresh in progress and store has no selection —
    // city routes may still be loading from GetRoutes; autorun will sync when data arrives
    const { selectedRouteNameList, isDataRefreshInProgress } = this.props.IBPlanningStore;
    const shouldSyncSelection = !isDataRefreshInProgress || selectedRouteNameList.length > 0;
    if (shouldSyncSelection) {
      this.selectRoutes(selectedRouteNameList, false);
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.syncSelectionOnGridReady();
    this.resizeRouteColumn({api});
    this.gridApi.redrawRows();
    this.updateLoadingGuideMenuStatus();
  };

  resizeRouteColumn = ({api}) => {
    api.autoSizeColumns(["routeName"])
  }

  selectRoutes = (routeNameList, ensureIndexVisible = true) => {
    if (this.gridApi && this.gridApi.forEachNode) {
      this.gridApi.forEachNode((node) => {
        if (routeNameList.includes(node.data.routeName)) {
          if (ensureIndexVisible) {
            this.gridApi.ensureIndexVisible(node.rowIndex);
          }
          node.setSelected(true, false, true); // props are isSelected, clearOtherSelection, suppressFinishActions
        } else {
          // disabling supress finish actions calls onSelectionChanged event for each selection
          node.setSelected(false, false, true); // but we want single call of onSelectionChanged for multiselection , behaviour observed through user action
        } // so we suppress the call from setSelected and call it explicitly after loop completes
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };

  onSelectionChanged = (params) => {
    this.updatedSelectedRoutes();

    const selectedDeliveryRoutesCount = this.selectedRoutes.filter(
      (route) =>
        !route.isTrapRoute && route.routeName !== appConstant.UNRTD_ROUTENAME
    ).length;
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_EnableTSP`,
      selectedDeliveryRoutesCount > 0
    );
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_EnableMergeRoutes`,
      selectedDeliveryRoutesCount > 1
    );
    //rerender routeName column to show route colors when selection of route changes on the grid
    this.gridApi.refreshCells({ columns: ["routeName"], force: true });
    this.updateLoadingGuideMenuStatus();
  };

  onRowClicked = (params) => {
    if (
      this.props.IBPlanningStore.newRoutesTobeCleared &&
      this.props.IBPlanningStore.newRoutesTobeCleared !== params.data.routeName
    ) {
      const filteredRoutes =
        this.props.IBPlanningStore.newShipments &&
        this.props.IBPlanningStore.newShipments.data &&
        this.props.IBPlanningStore.newShipments.data.filter(
          (routeData) =>
            routeData.routeName !==
            this.props.IBPlanningStore.newRoutesTobeCleared
        );
      const updatedNewShipments = {
        scenarioID: this.props.IBPlanningStore.newShipments.scenarioID,
        data: filteredRoutes,
      };
      //this.props.IBPlanningStore.updateNewShipments(updatedNewShipments);
      this.props.glEventHub.emit("UpdateIBStore", "updateNewShipments", [
        updatedNewShipments,
      ]);
      this.gridApi.refreshCells({ columns: ["violation"], force: true });
    }
    //this.props.IBPlanningStore.updateNewRoutesToBeCleared(params.data.routeName);
    this.props.glEventHub.emit("UpdateIBStore", "updateNewRoutesToBeCleared", [
      params.data.routeName,
    ]);
  };

  runTSP = () => {
    const requestParams = {
      scenarioId: this.props.userData.userProfile.scenarioID,
      routeNames: this.selectedRoutes
        .filter(
          (route) =>
            !route.isTrapRoute &&
            route.routeName !== appConstant.UNRTD_ROUTENAME
        )
        .map((route) => route.routeName),
    };
    this.isDataUpdated = true;
    postData("runTSP", requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(
            `${requestParams.routeNames.length} route(s) optimized`,
            { variant: "success" }
          );
          //Events.emit("RefreshIBStore", false, this.props.IBPlanningStore.selectedRouteNameList);
          this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
            {
              showNotification: false,
              selectedRoutesList: this.props.IBPlanningStore.selectedRouteNameList,
            }
          ]);
          return;
        }
        this.handleRunTSPError(response.status);
      },
      () => {
        this.handleRunTSPError();
      }
    );
    // enable button after TSP is complete

    //Log telemetry, we can log this any where because it is an async operation and won't block main thread
    const eventSpecificData = {
      routes: this.props.IBPlanningStore.selectedRouteNameList.join(","),
    };
    RMAXLogger.info("TSP", eventSpecificData);
  };

  handleRunTSPError = (statusCode) => {
    this.props.glEventHub.emit(`${this.gridHeaderId}_EnableTSP`, true);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(MESSAGES.RUN_TSP.FAILURE, {
      variant: "error",
    });
  }

  confirmMergeRoute = (showMergeRoutesModal = true) => {
    this.setState({
      showMergeRoutesModal: showMergeRoutesModal,
    });
  };

  // mergeRoutes
  mergeRoutes = ({ selectedRoutes, mergedRouteName }) => {
    const  { isReadOnlyRole }  = this.props.userData.userProfile;
    const requestParams = {
      scenarioId: this.props.userData.userProfile.scenarioID,
      routeNames: selectedRoutes.map((route) => route.routeName),
      mergedRouteName: mergedRouteName,
    };

    this.props.glEventHub.emit(`${this.gridHeaderId}_EnableMergeRoutes`, false);
    if (!isReadOnlyRole) {
      this.props.enqueueSnackbar(MESSAGES.ROUTE_MERGE.IN_PROGRESS, {
        variant: "info",
      });
    }
    this.isDataUpdated = true;
    postData("MergeRoutes", requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(
            `Routes ${selectedRoutes
              .map((route) => route.routeName)
              .join(",")} merged to ${mergedRouteName}`,
            { variant: "success", style: { wordBreak: "break-all" } }
          );
          this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
            {
              showNotification: false,
              selectedRoutesList: [mergedRouteName],
              refreshAdditionalData: {fetchAnchorPoint: true}    
            }
          ]);
          return;
        }
        this.handleMergeRoutesError(response.status);
      },
      () => {
        this.handleMergeRoutesError();
      }
    );

    const eventSpecificData = {
      routes: this.props.IBPlanningStore.selectedRouteNameList.join(","),
      mergedRouteName: mergedRouteName,
    };
    RMAXLogger.info("MergeRoutes", eventSpecificData);
  };

  handleMergeRoutesError = (statusCode) => {
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_EnableMergeRoutes`,
      true
    );
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(MESSAGES.ROUTE_MERGE.FAILURE, {
      variant: "error",
    });
  }

  //When a cell value is Changed
  onCellValueChanged = (params) => {
    const field = params.colDef.field;
    const value = params.value;
    const routeList = [
      {
        routeId: params.data.routeId,
        routeName:
          field === "routeName" ? params.oldValue : params.data.routeName,
      },
    ];

    if (this.isUpdateValid({ routeList, field, value, currentCell: params })) {
      // For inline edit we are backing up data here because we wont get previous value from anywhere else
      this.routesBackupData = {};
      this.routesBackupData[params.data.routeId] = {
        [field]: params.oldValue,
      };
      if (field === "isTrapRoute" && value === false && params.data.isOnHold) {
        this.openCloseHoldProPopup();
        params.data[field] = params.oldValue;
        this.gridApi.refreshCells({ columns: [field], force: true });
        return;
      }
      if (field === "anchorPointName" || field === "trailerName" || field === "door") {
        params.data[field] = value && value.label ? value.label : value;
        this.gridApi.refreshCells({ columns: [field], force: true });
      }
      this.updateRoutesInfo({ routeList, field, value });
    } else {
      params.data[field] = params.oldValue;
      this.gridApi.refreshCells({ columns: [field], force: true });
    }
  };

  getIsGridColumnEditableFunction = (field) => {
    const columnDef = this.gridApi.getColumnDef(field);
    const bulkEditable = columnDef.bulkEditable;
    const editable = columnDef.editable;
    const isEditable = (route) => {
      if (bulkEditable !== undefined) {
        if (typeof bulkEditable === 'function') {
          return bulkEditable({ data: route });
        }
        return bulkEditable;
      }
      if (typeof editable === 'function') {
        return editable({ data: route });
      }
      return editable;
    }
    return isEditable
  }

  //handle bulk update case
  onBulkUpdate = ({ field, newValue }) => {
    const isEditable = this.getIsGridColumnEditableFunction(field);
    const routeList = this.gridApi
      .getSelectedRows()
      .filter((route) => isEditable(route))
      .map((route) => ({
        routeId: route.routeId,
        routeName: route.routeName,
        [field]: route[field],
      }));

    if (field === "startTime" || field === "loadCloseTime") {
      newValue = convertDateTimeToTimeString(newValue);
    }

    if (field === "isTrapRoute") {
      if (newValue.value === false && routeList.some(route => route.isOnHold)) {
        this.openCloseHoldProPopup();
        return;
      }
      newValue = newValue?.value;
    }

    let currentCell = null;
    if (routeList.length === 1) {
      currentCell = { oldValue: routeList[0][field] };
    }
    if (
      this.isUpdateValid({
        routeList,
        field,
        value: newValue,
        currentCell,
        isBulkEdit: true,
      })
    ) {
      this.updateRoutesUI({ routeList, field, value: newValue });
      this.updateRoutesInfo({ routeList, field, value: newValue });
    }
  };

  isUpdateValid = ({ routeList, field, value, currentCell, isBulkEdit }) => {
    if (routeList.length === 0) {
      const message = ["routeName", "status", "comments", "trailerNumber"].includes(field)
        ? MESSAGES.ROUTE_UPDATE.NO_ROUTE_SELECTED
        : MESSAGES.ROUTE_UPDATE.NO_NONTRAPROUTE_SELECTED;
      this.props.enqueueSnackbar(message, { variant: "error" });
      return false;
    }
    let isUpdateValid = true;
    switch (field) {
      case "routeName":
        if (!value) {
          this.props.enqueueSnackbar(
            `Please update with valid routeName of format ${this.props.configJSON?.routeNameEditParams.placeholder}`,
            { variant: "error" }
          );
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          // If we try bulk edit for single row and value is not changed, show UI cue that nothing was changed
          if (isBulkEdit) {
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          }
          isUpdateValid = false;
        } else if (routeList.length > 1) {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_UPDATE.ROUTENAME_EXISTS, {
            variant: "error",
          });
          isUpdateValid = false;
        } else {
          const routeNameCount = this.props.IBPlanningStore.routesList.filter(
            (route) => route.routeName === value
          );
          // If case of inline editing store will be already updated, so we need to check if routeName count is 2
          if (
            (currentCell && routeNameCount.length === 2) ||
            (isBulkEdit && routeNameCount.length === 1)
          ) {
            this.props.enqueueSnackbar(`A route with name ${value} already exists`, {
              variant: 'error'
            });
            isUpdateValid = false;
          }
          if (
            handleWhiteGloveRouteNameChange({
              routeName: currentCell?.oldValue,
              snackbar: this.props.enqueueSnackbar
            })
          ) {
            isUpdateValid = false;
          }
        }
        break;
      case "startTime":
        if (!value) {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_UPDATE.STARTTIME_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (value && !isTimeValid(value)) {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_UPDATE.STARTTIME_INVALID, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "anchorPointName":
        if (
          currentCell &&
          (currentCell.oldValue === value ||
            (value && currentCell.oldValue === value.label))
        ) {
          // If we try bulk edit for single row and value is not changed, show UI cue that nothing was changed
          if (isBulkEdit) {
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          }
          isUpdateValid = false;
        }
        break;
      case "status":
        if (value === null) {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_UPDATE.STATUS_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        }
        if (
          currentCell &&
          (currentCell.oldValue === value ||
            (value && currentCell.oldValue === value.value))
        ) {
          // If we try bulk edit for single row and value is not changed, show UI cue that nothing was changed
          if (isBulkEdit) {
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          }
          isUpdateValid = false;
        }
        break;
      case "trailerName":
        if (!value) {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_UPDATE.TRAILER_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value.label) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "isTrapRoute":
        if (![true,false].includes(value)) {
          this.props.enqueueSnackbar(MESSAGES.ROUTE_UPDATE.ROUTETYPE_EMPTY, {
            variant: "error",
          });
          isUpdateValid = false;
        } else if (currentCell && currentCell.oldValue === value) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "door":
      if (currentCell && currentCell.oldValue === value?.label) {
            isBulkEdit &&
              this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
                variant: "info",
            });
          isUpdateValid = false;
        }
        break;
      case "driverName":
        if (currentCell && currentCell.oldValue === value?.label) {
          isBulkEdit &&
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info"
            });
          isUpdateValid = false;
        }
        break;
      default:
        if (currentCell && currentCell.oldValue === value) {
          if (isBulkEdit) {
            this.props.enqueueSnackbar(MESSAGES.COMMON.NO_CHANGES_TO_SAVE, {
              variant: "info",
            });
          }
          isUpdateValid = false;
        }
        break;
    }
    return isUpdateValid;
  };

  // Updates the UI (which in turn will updated the store) to display updated values & creates a backup of existing values for restore on failure
  updateRoutesUI = ({ routeList, field, value }) => {
    this.routesBackupData = {};
    if (field === "anchorPointName" || field === "trailerName" || field === "door") {
      value = value ? value.label : value;
    } else if (field === "status") {
      value = value ? value.value : value;
    }

    this.gridApi.forEachNode((node, id) => {
      const route = node.data;
      if (
        routeList.findIndex(
          (selectedRoute) => selectedRoute.routeId === route.routeId
        ) > -1
      ) {
        this.routesBackupData[route.routeId] = {
          [field]: route[field],
        };
        route[field] = value;
      }
    });
    this.gridApi.refreshCells();
  };

  // Updates the UI(which in turn will updated the store) to the value available from backup
  restoreRouteData = ({ routeList, field }) => {
    this.gridApi.forEachNode((node) => {
      if (
        routeList.findIndex(
          (selectedRoute) => selectedRoute.routeId === node.data.routeId
        ) > -1
      ) {
        node.data[field] = this.routesBackupData[node.data.routeId][field];
      }
    });
    this.selectRoutes(
      routeList.map((route) => route.routeName),
      true
    );
    this.gridApi.refreshCells();
  };

  getRequestParams = ({ routeList, field, value }) => {
    let requestParams = {
      scenarioId: this.props.userData.userProfile.scenarioID,
    };
    if (field === "anchorPointName") {
      requestParams.routeNames = routeList.map((route) => route.routeName);
      requestParams.anchorPointName = value ? value.value : null;
    } else if (field === "routeName") {
      requestParams.routes = routeList.map((route) => ({
        routeName: route.routeName,
        newRouteName: value,
      }));
    } else if (field === "isTrapRoute") {     
      requestParams.routes = routeList.map((route) => ({
        routeName: route.routeName,
      }));
      requestParams.isTrapRoute = value;
    } else {
      let fieldName = field;
      if (field === "trailerName"){
        fieldName= "trailerId";
      } else if (field === "driverName"){
        fieldName= "driverNumber";
      }
      requestParams.routes = routeList.map((route) => ({
        routeName: route.routeName,
        [fieldName]: value && typeof value === "object" ? value.value : sanitizeInput(value),
      }));
    }
    return requestParams;
  };
  updateRoutesInfo = ({ routeList, field, value }) => {
    const requestParams = this.getRequestParams({ routeList, field, value });
    this.props.glEventHub.emit(`${this.gridHeaderId}_DisableEditSave`, true);
    const { headerTooltip } = this.gridApi.getColumnDef(field);
    let apiName = "";
    switch (field) {
      case "anchorPointName":
        apiName = "UpdateRouteAnchorPoint";
        break;
      case "isTrapRoute":
        apiName = "ConvertRoutes";
        break;
      default:
        apiName = "UpdateRoutes";
    }
    postData(apiName, requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(`${headerTooltip} updated`, {
            variant: "success",
          });
          let selectedRoutes = this.props.IBPlanningStore.selectedRouteNameList;
          if (field === "routeName") {
            // if selection has not changed updated the selected routeName
            selectedRoutes =
              this.selectedRoutes.length === 1 &&
              this.selectedRoutes[0].routeName ===
                requestParams.routes[0].routeName
                ? [requestParams.routes[0].newRouteName]
                : this.props.IBPlanningStore.selectedRouteNameList;
          }
          this.routesBackupData = {};
          this.props.glEventHub.emit(
            `${this.gridHeaderId}_showEditMode`,
            false
          );
          this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
            {
              showNotification: false,
              selectedRoutesList: selectedRoutes,
              refreshAdditionalData: {fetchAnchorPoint: ["isTrapRoute", "anchorPointName", "routeName"].includes(field)}
            }
          ]);
          this.props.glEventHub.emit(
            `${this.gridHeaderId}_DisableEditSave`,
            false
          );
          return;
        }
        this.handleUpdateRoutesInfoError({routeList, field, headerTooltip, statusCode: response.status});
      },
      () => {
        this.handleUpdateRoutesInfoError({routeList, field, headerTooltip});
      }
    );
  };

  handleUpdateRoutesInfoError = ({routeList, field, headerTooltip, statusCode}) => {
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_DisableEditSave`,
      false
    );
    this.restoreRouteData({ routeList, field });
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(`Failed to update ${headerTooltip}`, {
      variant: "error",
    }); 
  }

  updatedSelectedRoutes = () => {
    this.selectedRoutes = this.gridApi.getSelectedRows().map((route) => {
      return {
        routeId: route.routeId,
        routeName: route.routeName,
        isTrapRoute: route.isTrapRoute,
      };
    });
    
    const routeNames = this.selectedRoutes.map((route) => route.routeName);

    const isEnforcedDREnabled = this.props.featureFlags.isFeatureEnabled(
      appConstant.features.EnableEnforcedDynamicRoutingFromShipmentSelection
    );
    const cityRoutes =
      isEnforcedDREnabled && this.props.IBPlanningStore.isFirstOptimizationRun
        ? this.props.IBPlanningStore.cityRouteNamesForEnforcedDR
        : [];
    const emitList = cityRoutes.length > 0 ? cityRoutes : routeNames;

    this.clearSelectionTimeout();
    this.rowSelectionTimeOut = setTimeout(() => {
      this.props.glEventHub.emit("UpdateIBStore", "updateSelectedRoutes", [emitList]);
      this.rowSelectionTimeOut = null;
    }, appConstant.SEARCH_DEBOUNCE_DELAY);
  };

  updateModalVisibility = (showUnrtdShipmentModal) => {
    this.setState({ showUnrtdShipmentModal });
  };

  openUNRTDModal = () => {
    this.updateModalVisibility(true);
  }

  onCellClicked = (params) => {
    if (params.value === appConstant.UNRTD_ROUTENAME) {
      this.openUNRTDModal();
    }
  };

  doesExternalFilterPass = (node) => {
    switch (this.state.filterData) {
      case "MissedApt":
        return node.data.numServiceViolations > 0;
      case "LateShipments":
        return Boolean(
         CheckViolation.checkRouteProArrivingLate({data: node.data, context: this.gridContext})
        );
      case "TrapRoutes":
        return node.data.isTrapRoute;
      case "NewPros":
        return Boolean(
          CheckViolation.checkNewProsInRoute({
            data: node.data,
            context: this.gridContext,
          })
        );
      case "OpenRoutes":
        return !node.data.isClosed;
      case "ClosedRoutes":
        return node.data.isClosed;
      case "UniqueDrivers":
        return routeHasAssignedDriver(node.data);
      default:
        return true;
    }
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged?.()
    );
  };

  constructStatusBar = (routesListData) => {
    const routesList =
      routesListData.length > 0
        ? routesListData.filter(
            (route) => route.routeName != appConstant.UNRTD_ROUTENAME
          )
        : [];

    const missedAptCount =
      routesList.length > 0
        ? routesList.filter((route) => route.numServiceViolations > 0).length
        : 0;

    const trapRoutesCount =
      routesList.length > 0
        ? routesList.filter((routes) => routes.isTrapRoute).length
        : 0;

    const lateProsCount = routesList
      ? routesList.filter((routes) =>
          Boolean(
            CheckViolation.checkRouteProArrivingLate({
              data: routes,
              context: this.gridContext,
            })
          )
        ).length
      : 0;

    const newProsCount = routesList
      ? routesList.filter((routes) =>
          Boolean(
            CheckViolation.checkNewProsInRoute({
              data: routes,
              context: this.gridContext,
            })
          )
        ).length
      : 0;

    const openRoutesCount =
      routesList.length > 0
        ? routesList.filter((route) => !route.isClosed).length
        : 0;

    const closedRoutesCount =
      routesList.length > 0
        ? routesList.filter((route) => route.isClosed).length
        : 0;

    const uniqueDriverCount = getUniqueDriverCount(routesList);

    const statusBarData = [
      {
        label: routesList.length + " Routes",
        filterCondition: "",
      },
      {
        label: missedAptCount + " Missed Apts Routes",
        filterCondition: "MissedApt",
      },
      {
        label: newProsCount + " New",
        filterCondition: "NewPros",
      },
      {
        label: lateProsCount + " Arriving Late",
        filterCondition: "LateShipments",
      },
      {
        label: trapRoutesCount + " Trap Routes",
        filterCondition: "TrapRoutes",
      },
      {
        label: openRoutesCount + " Open Routes",
        filterCondition: "OpenRoutes",
      },
      {
        label: closedRoutesCount + " Closed Routes",
        filterCondition: "ClosedRoutes",
      },
      {
        label: uniqueDriverCount + " Unique Drivers",
        filterCondition: "UniqueDrivers",
      }
    ];
    return statusBarData;
  };

  onCellFocused = (params) => {
    if (this.props.IBPlanningStore.isLassoRouteCreated) {
      this.props.glEventHub.emit(appConstant.Event.CLOSE_LASSO_PANEL);
    } else if (this.state.isLassoActiveWithShipments) {
      const isAlreadySelected =
        this.props.IBPlanningStore.selectedRouteNameList.includes(
          params.data.routeName
        );
      if (!params.event.ctrlKey || isAlreadySelected) {
        this.setState({
          lassoSelectRoute: params.data.routeName,
          isAlreadySelected,
        });
      }
    }
  };

  cancelRouteSelection = () => {
    this.setState({
      lassoSelectRoute: null,
    });
  };

  confirmRouteSelection = () => {
    let updatedSelectedRouteList = [];
    if (this.state.isAlreadySelected) {
      updatedSelectedRouteList =
        this.props.IBPlanningStore.selectedRouteNameList.filter(
          (routeName) => routeName !== this.state.lassoSelectRoute
        );
    } else {
      updatedSelectedRouteList = [
        ...this.props.IBPlanningStore.selectedRouteNameList,
        this.state.lassoSelectRoute,
      ];
    }
    //this.props.IBPlanningStore.updateSelectedRoutes(updatedSelectedRouteList);
    this.props.glEventHub.emit("UpdateIBStore", "updateSelectedRoutes", [
      updatedSelectedRouteList,
    ]);
    this.cancelRouteSelection();
  };

  onRowDataUpdated = () => {
    if (this.datarefreshed) {
      this.selectRoutes(
        this.props.IBPlanningStore.selectedRouteNameList,
        false
      );
    }
    this.gridApi.refreshCells({ columns: ["violation"], force: true });
    this.datarefreshed = false;
    this.updateLoadingGuideMenuStatus();
  };

  getSelectedRoutes = () => {
    return this.gridApi.getSelectedRows();
  }

  updateLoadingGuideMenuStatus = () => {
    const selectedRoutes = this.gridApi.getSelectedRows();
    this.props.glEventHub.emit('updateLoadingGuideMenuStatus', selectedRoutes);
  };
  
  openCloseHoldProPopup = () => {
    this.setState({
      showHoldProPopup: !this.state.showHoldProPopup      
    });
  }
  render() {
    const routesList =
      this.props.IBPlanningStore.routesList.length > 0
        ? this.props.IBPlanningStore.routesList.slice()
        : [];
    return (
      <React.Fragment>
        <DataGrid
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={routesList}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged}
          onCellValueChanged={this.onCellValueChanged}
          panelLabel={(filteredData) => (
            <StatusBar
              data={this.constructStatusBar(filteredData)}
              filterGridData={this.updateGridData}
            />
          )}
          onFirstDataRendered={this.resizeRouteColumn}
          quickFilterText={this.state.quickFilterText}
          layoutContainer={this.props.glContainer}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.routeKey}
          onRowDataUpdated={this.onRowDataUpdated} // this is called when IBstore is refreshed
          onCellClicked={this.onCellClicked}
          onRowClicked={this.onRowClicked}
          onCellMouseDown={this.onCellFocused}
          accentedSort={true}
          isExternalFilterPresent={() => Boolean(this.state.filterData)}
          doesExternalFilterPass={this.doesExternalFilterPass}
          context={this.gridContext}
          suppressRowClickSelection={this.state.isLassoActiveWithShipments}
          showErrorMessage={this.props.IBPlanningStore.routeGridMessage}
        />
        {this.state.showUnrtdShipmentModal && (
          <UNRTDShipmentsModal
            show={this.state.showUnrtdShipmentModal}
            onClose={() => {
              this.updateModalVisibility(false);
            }}
          />
        )}
        {this.state.showMergeRoutesModal && (
          <MergeRoutesDialog
            routesList={this.props.IBPlanningStore.routesList}
            selectedRoutes={this.selectedRoutes.filter(
              (route) =>
                !route.isTrapRoute &&
                route.routeName !== appConstant.UNRTD_ROUTENAME
            )}
            close={() => {
              this.confirmMergeRoute(false);
            }}
            confirm={this.mergeRoutes}
          />
        )}
        {this.state.lassoSelectRoute && (
          <AddRouteToLassoModal
            isAlreadySelected={this.state.isAlreadySelected}
            routeName={this.state.lassoSelectRoute}
            onClose={this.cancelRouteSelection}
            onConfirm={this.confirmRouteSelection}
          />
        )}
        {this.props.configJSON?.enablePrintLoadingGuide && (
          <PrintLoadingGuide
            getSelectedRoutes={this.getSelectedRoutes}
            userProfile={this.props.userData.userProfile}
            IBPlanningStore={this.props.IBPlanningStore}
            columnConfig={this.props.configJSON?.gridColumnConfig}
            enqueueSnackbar={this.props.enqueueSnackbar}
            configJSON={this.props.configJSON}
          />
        )}
         {this.state.showHoldProPopup && (
          <HoldProPopup isRouteGrid onCancel={this.openCloseHoldProPopup} />
        )}
      </React.Fragment>
    );
  }
}
export default compose(withUserProfile, withSnackbar, withFeatureFlags, withAppConfig)(RoutesGrid);
